"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledDivider = _styledComponents["default"].div.attrs({
  className: 'fuse-divider',
  'data-testid': 'fuse-divider'
}).withConfig({
  displayName: "styled-divider__StyledDivider",
  componentId: "sc-1ih10v4-0"
})(["", ""], function (_ref) {
  var color = _ref.color,
    size = _ref.size;
  return "\n\t\tborder: 0;\n\t\tborder-bottom: ".concat(size, " solid ").concat(color, ";\n\t\tmargin: 0;\n\t\twidth: 100%;\n\t");
});
var _default = exports["default"] = StyledDivider;